<template lang="pug">
.alert.alert-warning(v-if="err") {{err.message}}
div.has-fixed-footer(v-else)
    .form-row(v-if="collections.length > 0")
        .form-group.col-md-4
            label.mb-1 Name
            input.form-control(
                v-model="nameFilter",
                type="text",
                placeholder="Filter collections by name"
            )
        .form-group.col-md-4
            label.mb-1 Type
            MultipleSelect(:labels="CollectionTypes", v-model="typeFilter")
        .form-group.col-md-4
            label.mb-1 Materials
            MultipleSelect(:labels="MaterialTypes", v-model="materialsFilter")
    .form-row(v-if="collections.length > 0")
        .form-group.col-md-4
            label.mb-1 Facts
            select.form-control(v-model="factFilter")
                option(value="all") All collections
                option(value="with_facts") With fact data
                option(value="without_facts") Without fact data
        .form-group.col-md-8.d-flex.align-items-end
            .form-check
                input.form-check-input(type="checkbox", id="cohortOnly", v-model="cohortOnly")
                label.form-check-label(for="cohortOnly") Show only cohort collections
    CollectionTable(v-if="filteredCollections.length > 0", :collections="filteredCollections", :showSubcollections="false")
    .alert.alert-light(v-else)
        | {{ hasActiveFilters ? "No collections satisfies the current filter" : "No collections are defined for this biobank" }}
    .page-action-footer
        .container
            router-link(to="/collection-new").btn.btn-success Add Collection
</template>

<script>
import CollectionTable from "./CollectionTable.vue";
import MultipleSelect from "./MultipleSelect.vue";
import {getCollectionsByBiobank} from "../api";
import CollectionTypes from "../labels/CollectionTypes.json";
import MaterialTypes from "../labels/MaterialTypes.json";

export default {
    components: {CollectionTable, MultipleSelect},
    data() {
        return {
            err: null,
            collections: [],
            nameFilter: "",
            factFilter: "all",
            cohortOnly: false,
            typeFilter: [],
            materialsFilter: [],
            CollectionTypes,
            MaterialTypes
        }
    },
    computed: {
        hasActiveFilters() {
            return (this.nameFilter || "").trim().length > 0
                || this.factFilter !== "all"
                || this.cohortOnly
                || this.typeFilter.length > 0
                || this.materialsFilter.length > 0;
        },
        filteredCollections() {
            const needle = (this.nameFilter || "").trim().toLowerCase();
            const byName = this.collections.filter(collection => {
                const name = ((collection && collection.name) || "").toLowerCase();
                return name.includes(needle);
            });
            return byName.filter(collection => {
                if (this.cohortOnly && !collection.flagged_as_cohort) return false;
                if (this.typeFilter.length > 0) {
                    const collectionTypes = Array.isArray(collection.type) ? collection.type : [];
                    const hasSelectedType = this.typeFilter.some(type => collectionTypes.includes(type));
                    if (!hasSelectedType) return false;
                }
                if (this.materialsFilter.length > 0) {
                    const collectionMaterials = Array.isArray(collection.materials) ? collection.materials : [];
                    const hasSelectedMaterial = this.materialsFilter.some(material => collectionMaterials.includes(material));
                    if (!hasSelectedMaterial) return false;
                }
                const info = collection.fact_info || {};
                const explicit = info.explicit_count || 0;
                const derived = info.derived_count || 0;
                const total = explicit + derived;
                if (this.factFilter === "with_facts") return total > 0;
                if (this.factFilter === "without_facts") return total === 0;
                return true;
            });
        }
    },
    created() {
        getCollectionsByBiobank(localStorage.getItem("biobank"))
        .then(collections => this.collections = collections)
        .catch(err => this.err = err);
    },
}
</script>
